export const useStyles = () => {
  return {
    container: {
      width: '100%',
      height: '100%',
    },
    textField: {
      width: '100%',
      height: '100%',
      '& .MuiOutlinedInput-root': {
        backgroundColor: 'rgba(175, 175, 175, 0.1)',
        border: '1px solid rgba(175, 175, 175, 0.3)',
        borderRadius: '8px',
        color: '#FFF',
        fontFamily: 'Noto Sans',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '120%',
        letterSpacing: '-0.56px',
        '&:hover': {
          border: '1px solid rgba(175, 175, 175, 0.5)',
        },
        '&.Mui-focused': {
          border: '1px solid rgba(175, 175, 175, 0.7)',
          boxShadow: '0 0 0 2px rgba(175, 175, 175, 0.1)',
        },
        '& .MuiOutlinedInput-notchedOutline': {
          border: 'none',
        },
                  '& .MuiInputBase-input': {
            padding: '12px',
            color: '#FFF',
            fontFamily: 'Noto Sans',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '120%',
            letterSpacing: '-0.56px',
            '@media (max-width: 1023px)': {
              fontSize: '13px',
              padding: '10px',
            },
            '@media (max-width: 767px)': {
              fontSize: '12px',
              padding: '8px',
            },
            '@media (max-width: 480px)': {
              fontSize: '11px',
              padding: '8px',
            },
            '&::placeholder': {
              color: '#AFAFAF',
              fontFamily: 'Noto Sans',
              fontSize: '14px',
              fontStyle: 'italic',
              fontWeight: 400,
              lineHeight: '120%',
              letterSpacing: '-0.56px',
              opacity: 1,
              '@media (max-width: 1023px)': {
                fontSize: '13px',
              },
              '@media (max-width: 767px)': {
                fontSize: '12px',
              },
              '@media (max-width: 480px)': {
                fontSize: '11px',
              },
            },
          },
      },
    },
    counterContainer: {
      display: 'flex',
      justifyContent: 'flex-end',
      mt: 1,
    },
    counterText: {
      color: '#AFAFAF',
      fontFamily: 'Noto Sans',
      fontSize: '12px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '120%',
      '@media (max-width: 767px)': {
        fontSize: '11px',
      },
      '@media (max-width: 480px)': {
        fontSize: '10px',
      },
    },
  };
};
